import { modalCodeKeyParameterInterface } from '@/store/ModalCodeKeyStore'
import { modalCodeKeyStore } from '@/utils/store-accessor'

export class ModalCodeKeyService {
  public open(params: modalCodeKeyParameterInterface) {
    modalCodeKeyStore.open(params)
  }

  public close() {
    modalCodeKeyStore.close()
  }
}
